<template>
  <v-dialog :value="dialog" @input="$emit('update:dialog', $event)" max-width="600px" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
        <v-spacer></v-spacer>
        <v-icon @click="closeDialog" class="cursor-pointer">mdi-close</v-icon>
      </v-card-title>

      <v-card-text>
        <v-form ref="form" v-model="validForm" lazy-validation>
          <!-- Información Básica -->
          <v-row>
            <v-col cols="12">
              <div class="subtitle-2 font-weight-bold mb-3">Información de la Clínica</div>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select
                v-model="form.teacher_id"
                :items="teachers"
                item-text="name"
                item-value="id"
                label="Profesor"
                outlined
                dense
                :rules="[v => !!v || 'Profesor es requerido']"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select
                v-model="form.type"
                :items="typeOptions"
                label="Tipo de Clínica"
                outlined
                dense
                :rules="[v => !!v || 'Tipo es requerido']"
              ></v-select>
            </v-col>
          </v-row>

          <!-- Fecha y Hora -->
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="form.date"
                label="Fecha"
                type="date"
                outlined
                dense
                :rules="[v => !!v || 'Fecha es requerida']"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="form.time"
                label="Hora"
                type="time"
                outlined
                dense
                :rules="[v => !!v || 'Hora es requerida']"
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- Nivel y Capacidad -->
          <v-row>
            <v-col cols="12" sm="6">
              <v-select
                v-model="form.level"
                :items="levelOptions"
                label="Nivel"
                outlined
                dense
                :rules="[v => !!v || 'Nivel es requerido']"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model.number="form.capacity"
                label="Capacidad Máxima"
                type="number"
                outlined
                dense
                min="1"
                max="20"
                :rules="[v => v >= 1 || 'Capacidad debe ser mínimo 1']"
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- Descripción -->
          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="form.description"
                label="Descripción de la Clínica"
                outlined
                dense
                rows="2"
                counter
                maxlength="200"
              ></v-textarea>
            </v-col>
          </v-row>

          <!-- Información -->
          <v-row>
            <v-col cols="12">
              <v-alert type="info" outlined small>
                <div class="caption">
                  Al crear la clínica, los alumnos podrán inscribirse. La capacidad máxima es de {{ form.capacity }} alumnos.
                </div>
              </v-alert>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="closeDialog">Cancelar</v-btn>
        <v-btn color="primary" text @click="submitForm" :disabled="!validForm">
          {{ formTitle === 'Nueva Clínica' ? 'Programar' : 'Actualizar' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ClinicDialog',
  props: {
    dialog: Boolean,
    clinic: Object,
    teachers: Array
  },
  data () {
    return {
      validForm: false,
      typeOptions: [
        { text: 'Swing', value: 'swing' },
        { text: 'Putting', value: 'putting' },
        { text: 'Pitch', value: 'pitch' },
        { text: 'Swing Completo', value: 'full_swing' },
        { text: 'Juego Corto', value: 'short_game' }
      ],
      levelOptions: [
        { text: 'Básico', value: 'basico' },
        { text: 'Intermedio', value: 'intermedio' },
        { text: 'Avanzado', value: 'avanzado' }
      ],
      form: {
        teacher_id: null,
        type: '',
        date: '',
        time: '',
        level: '',
        capacity: 6,
        description: '',
        enrolled: 0
      }
    }
  },
  computed: {
    formTitle () {
      return this.clinic && this.clinic.id ? 'Editar Clínica' : 'Nueva Clínica'
    }
  },
  watch: {
    dialog (newVal) {
      if (newVal) {
        if (this.clinic && this.clinic.id) {
          this.form = { ...this.clinic }
        } else {
          this.resetForm()
        }
      }
    }
  },
  methods: {
    closeDialog () {
      this.$emit('update:dialog', false)
    },
    submitForm () {
      if (this.$refs.form.validate()) {
        this.$emit('save', { ...this.form })
        this.resetForm()
      }
    },
    resetForm () {
      if (this.$refs.form) {
        this.$refs.form.reset()
      }
      this.form = {
        teacher_id: null,
        type: '',
        date: '',
        time: '',
        level: '',
        capacity: 6,
        description: '',
        enrolled: 0
      }
      this.validForm = false
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
